import { postVisite } from "../api/postVisite";

/* eslint-disable */
export const setPostVisite = () => {
  return async (dispatch, getState) => {
    try {
      const params = {
        utm_term: localStorage.getItem('utm_term'),
        utm_source: localStorage.getItem('utm_source'),
        utm_medium: localStorage.getItem('utm_medium'),
        utm_campaign: localStorage.getItem('utm_campaign'),
        utm_content: localStorage.getItem('utm_content'),
        stream: localStorage.getItem('stream'),
        s1: localStorage.getItem('s1'),
        s2: localStorage.getItem('s2'),
        s3: localStorage.getItem('s3'),
        s4: localStorage.getItem('s4'),
        s5: localStorage.getItem('s5')
      }

      const { data } = await postVisite(params);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.replace(window.location.origin);
      }
    }
  }
}